import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import BookingStep1 from '../components/Booking/BookingStep1'
import BookingStep2 from '../components/Booking/BookingStep2'
import BookingStep3 from '../components/Booking/BookingStep3'
import StepsNavigate from '../components/Booking/components/StepsNavigate'
import BookingChoices from '../components/Booking/components/BookingChoices'
import MilesBonusAlert from '../components/Booking/components/MilesBonusAlert'
import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { setType } from '../../js/lib/redux/slices/booking'
import {
  setMilesNBonusAccount,
  resetMBData,
  resetMilesNBonusAccount,
} from '../../js/lib/redux/slices/booking'

const BookingRouter = () => {
  const { dictionary, pickUpDetails, dropOffDetails } =
    window.bookingData || window.modifyData

  const { milesNBonusAccount } = window.headerData || {}
  const isMBLoggedIn = useRef(undefined)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setType('booking'))
  }, [])

  useEffect(() => {
    const handleLoginSuccess = (event) => {
      const isLoggedIn = event.detail.isLoggedIn

      if (!isLoggedIn) {
        dispatch(resetMilesNBonusAccount())
        dispatch(resetMBData())
        isMBLoggedIn.current = false
      } else {
        dispatch(setMilesNBonusAccount(event.detail.data))
        isMBLoggedIn.current = true
      }
    }
    window.addEventListener('loggedIn', handleLoginSuccess)

    return () => {
      window.removeEventListener('loggedIn', handleLoginSuccess)
    }
  }, [])

  useEffect(() => {
    if (
      isMBLoggedIn.current === undefined &&
      !!milesNBonusAccount &&
      milesNBonusAccount?.fFN
    ) {
      dispatch(setMilesNBonusAccount(milesNBonusAccount))
    }
  }, [])

  return (
    <Router
      basename={window.location.pathname}
      future={{ v7_startTransition: true }}>
      <div>
        <StepsNavigate />
        <MilesBonusAlert />
        <div className="d-none d-lg-block">
          <BookingChoices
            dictionary={dictionary}
            pickUpDetails={pickUpDetails}
            dropOffDetails={dropOffDetails}
          />
        </div>
        <Routes>
          {/* <Route path="/" element={<Navigate to="/payment" replace />} /> */}
          <Route
            path="/choose"
            element={<BookingStep1 isMBLoggedIn={isMBLoggedIn} />}
          />
          <Route path="/extras" element={<BookingStep2 />} />
          <Route path="/payment" element={<BookingStep3 />} />
        </Routes>
      </div>
    </Router>
  )
}

export default BookingRouter
